import React, { useState, useEffect } from "react";
import { FormControl, TextField, Grid, Button, Card } from "@material-ui/core";
import api from "../../api";
import utils from "../../utils/utils";
import { DocumentTypes } from "../../enums/enums";
import iconLogo from "../../img/logoFull.png";
import SingleAutocomplete from "../common/singleAutocomplete/SingleAutocomplete";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";

const CustomTextField = ({
  Name,
  Label,
  Change,
  Blur,
  Value,
  Type,
  InputProps,
  FullWidth,
  Required,
  OnInput,
}) => {
  return (
    <FormControl fullWidth={FullWidth ?? false}>
      <TextField
        size="small"
        variant="outlined"
        name={Name}
        label={Label}
        onChange={Change}
        onBlur={Blur}
        type={Type ?? "text"}
        value={Value}
        inputProps={InputProps}
        onInput={OnInput}
        required={Required ?? false}
      />
    </FormControl>
  );
};

export default function AgreementCancel({ setIsLoading }) {
  const [loaded, setLoaded] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [cancelReasonsList, setCancelReasonsList] = useState();
  const [documentTypesList, setDocumentTypesList] = useState();
  const [maxLengthDocument, setMaxLengthDocument] = useState(8);
  const [data, setData] = useState({
    agreementId: undefined,
    documentType: undefined,
    documentNumber: undefined,
    birthDate: getMaxDate(),
    reasonCancel: undefined,
  });

  function saveData(e) {
    if (e) setData({ ...data, [e.target.name]: e.target.value });
  }

  function changeDocumentType(e) {
    setData({ ...data, documentType: e ? e.value : undefined });
    if (e) {
      switch (e.value) {
        case DocumentTypes.CUIT:
          setMaxLengthDocument(11);
          break;
        default:
          setMaxLengthDocument(8);
          break;
      }
    }
  }

  function changeReasonCancel(e) {
    if (e) setData({ ...data, reasonCancel: e.value });
  }

  function changeBirthDate(e) {
    if (e) setData({ ...data, birthDate: e });
  }

  function getMaxDate() {
    var date = new Date();
    date.setFullYear(date.getFullYear() - 18);

    return date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
  }

  function maxLengthCheck(object) {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  }

  function cancelAgreement(e) {
    e.preventDefault();
    setIsLoading(true);
    let date = new Date(data.birthDate);

    let body = {
      documentType: data.documentType,
      documentNumber: data.documentNumber,
      birthDate: moment(date).format("YYYY-MM-DD"),
    };
    api
      .deleteAgreementByData(data.agreementId, data.reasonCancel, body)
      .then(() => {
        setDeleted(true);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        utils.alertError("Error", "Error al dar de baja el contrato.");
      });
  }

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      api.getReasonsCancelList().then((res) => {
        setCancelReasonsList(utils.setDataInList(res.data));
      }),
      api.getDocumentTypes().then((res) => {
        setDocumentTypesList(utils.setDataInList(res.data));
      }),
    ])
      .then(() => {
        setIsLoading(false);
        setLoaded(true);
      })
      .catch(() => {
        setIsLoading(false);
        utils.alertError(
          "Error",
          "Erorr al cargar la página, recargar nuevamente."
        );
      });
  }, []);

  return (
    <>
      {loaded && (
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          className="c-login"
        >
          <Grid className="c-w-100 c-p-25" item md={5} xs={8}>
            <Card className="c-agcc-card" elevation={3}>
              <Grid className="c-agcc-card-header" container>
                <Grid item xs={12} md={12}>
                  <h4>Baja de una contratación</h4>
                </Grid>
              </Grid>
              {!deleted && (
                <Grid className="c-agcc-card-body" container>
                  <Grid
                    className="c-agcc-card-body-header"
                    item
                    xs={12}
                    md={12}
                  >
                    <img className="img c-mb-10" src={iconLogo} />
                  </Grid>
                  <Grid
                    className="c-agcc-card-body c-mt-25 c-mb-25 c-p-10 c-text-center"
                    container
                  >
                    <Grid item xs={2} />
                    <Grid item xs={8}>
                      <form onSubmit={cancelAgreement}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={12}>
                            <CustomTextField
                              Label="Nro. de Contrato"
                              FullWidth={true}
                              Change={saveData}
                              Blur={saveData}
                              InputProps={{ min: 0, maxLength: 7 }}
                              OnInput={maxLengthCheck}
                              Name="agreementId"
                              Value={data.agreementId}
                              Type="number"
                              Required={true}
                            />
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <Grid container spacing={1}>
                              <Grid item xs={5}>
                                <SingleAutocomplete
                                  DataList={documentTypesList}
                                  Label="Tipo Doc."
                                  Name="documentType"
                                  SetValue={changeDocumentType}
                                  Required={true}
                                />
                              </Grid>
                              <Grid item xs={7}>
                                <CustomTextField
                                  Label="Nro. de documento"
                                  FullWidth={true}
                                  Change={saveData}
                                  Blur={saveData}
                                  InputProps={{
                                    min: 0,
                                    maxLength: maxLengthDocument,
                                  }}
                                  OnInput={maxLengthCheck}
                                  Name="documentNumber"
                                  Type="number"
                                  Required={true}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <FormControl fullWidth={true}>
                              <KeyboardDatePicker
                                className="c-datepicker"
                                label="Fecha de nacimiento"
                                inputVariant="outlined"
                                okLabel="Seleccionar"
                                cancelLabel="Cancelar"
                                format="dd/MM/yyyy"
                                value={data.birthDate}
                                onChange={changeBirthDate}
                                maxDate={data.birthDate}
                                invalidDateMessage="Fecha inválida"
                                required
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <SingleAutocomplete
                              DataList={cancelReasonsList}
                              Label="Motivo de baja"
                              Required={true}
                              SetValue={changeReasonCancel}
                            />
                          </Grid>
                          <Grid
                            className="c-agcc-card-body-btn"
                            item
                            xs={12}
                            md={12}
                          >
                            <Button
                              className="c-btn-primary-confirm"
                              type="submit"
                            >
                              Dar de baja
                            </Button>
                          </Grid>
                        </Grid>
                      </form>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {deleted && (
                <Grid className="c-agcc-card-body c-mt-0" container>
                  <Grid
                    className="c-agcc-card-body c-mt-25 c-mb-25 c-p-10 c-text-center"
                    container
                  >
                    <Grid item xs={12}>
                      <h4>El contrato fue dado de baja correctamente.</h4>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>
      )}
    </>
  );
}
